import { useNavigate, useLocation, useParams } from "react-router";
import { useState, useRef, useEffect, useContext } from "react";
import "./style.css";
import { SwalContext, ThemeContext } from "../../layout/BaseLayout";
import MenuNameComp from "./menuNameComp";
import { toast } from "react-toastify";
import { UserProfileContext } from "../../App";

let transparent = require("../../images/transparent.png");

export default function SideBar3(props: any) {
  let navigate: any = useNavigate();
  let userAuthData: any = sessionStorage.getItem("userAuthData");
  userAuthData = JSON.parse(userAuthData);
  let token = sessionStorage.getItem("token");
  let navigationId: any = sessionStorage.getItem("selectedId");
  navigationId = JSON.parse(navigationId);

  const [plusMinus, setPlusMinus] = useState(false);
  const [plusMinusVersion, setPlusMinusVersion] = useState(false);

  // let location: any = useLocation();
  // let paramId: any = useParams();
  // let toast: any = useContext(ThemeContext);
  // let Swal: any = useContext(SwalContext);
  // let userProfile: any = useContext(UserProfileContext);

  // const [data, setData] = useState<any[]>([]);
  // const [dataUpdateFlag, setDataUpdateFlag] = useState(0);

  // const [contextSymbol, setContextSymbol] = useState(false);
  // const [openCloseArr, setOpenCloseArr] = useState<any>([]);
  // const [xYPosition, setXYPosition] = useState({ x: 0, y: 0 });
  // const [chosen, setChosen] = useState();
  // const indexOfMenuObj: any = {
  //   "symbolsecurity": null,
  //   "mastersymbol": null,
  //   "symbols": null,
  //   "groups": null,
  //   "dealers": null,
  //   "clients": null,
  // };
  // const [indexOfMenu, setIndexOfMenu] = useState<any>({ ...indexOfMenuObj });
  // const [newFolder, setNewFolder] = useState(false);
  // const [selectedItem, setSelectedItem] = useState<any>();
  // const [selectedNavigation, setSelectedNavigation] = useState<any>();
  // const [userProfileList, setUserProfileList] = useState<any>([]);
  // const selectedRouteId = useRef<any>();
  // const newFolderNameRef = useRef("");
  // let userAuthData: any = sessionStorage.getItem("userAuthData");
  // userAuthData = JSON.parse(userAuthData);

  // const [dropArr, setDropArr] = useState<any>([]);
  // const [levelPathIdDic, setLevelPathIdDic] = useState<any>({});

  const clickOnMenuName = (routename: any, id: any) => {
    navigate(routename);
    sessionStorage.setItem("selectedId", JSON.stringify(id));
  }

  return (
    <>
      <div className="treeview">
        {window.location.pathname !== "/" && !!token && (
          <div className="main_ul ">
            <div onClick={() => clickOnMenuName("/home", 1)}>
              <img src="./images/svg/home.svg" className="sideBar_image" alt="" />
              <span className={`${navigationId === 1 ? 'left-menu-select' : ''}`}>Home</span>
            </div>
            <div onClick={() => clickOnMenuName("/feedmodules", 2)}>
              <img src="./images/svg/feeder.svg" className="sideBar_image" alt="" />
              <span className={`${navigationId === 2 ? 'left-menu-select' : ''}`}>Feed Modules</span>
            </div>
            <div onClick={() => clickOnMenuName("/licencemaster", 3)}>
              <img
                src="./images/svg/licence-valid.svg"
                className="sideBar_image" alt=""
              />
              <span className={`${navigationId === 3 ? 'left-menu-select' : ''}`}>Licence Master</span>
            </div>
            <div onClick={() => clickOnMenuName("/modulemaster", 4)}>
              <img
                src="./images/svg/module-master.svg"
                className="sideBar_image" alt=""
              />
              <span className={`${navigationId === 4 ? 'left-menu-select' : ''}`}>Module Master</span>
            </div>
            <div onClick={() => clickOnMenuName("/versionmaster", 5)}>
              <img
                src="./images/svg/version-icon.svg"
                className="sideBar_image" alt=""
              />
              <span className={`${navigationId === 5 ? 'left-menu-select' : ''}`}>Version Master</span>
            </div>
            <div onClick={() => clickOnMenuName("/managelogin", 6)}>
              <img
                src="./images/svg/managelogin.svg"
                className="sideBar_image" alt=""
              />
              <span className={`${navigationId === 6 ? 'left-menu-select' : ''}`}>Manage Login</span>
            </div>
            {/* <div onClick={() => clickOnMenuName("/vendormaster", 7)}>
              <img
                src="./images/svg/vendor.svg"
                className="sideBar_image" alt=""
              />
              <span className={`${navigationId === 7 ? 'left-menu-select' : ''}`}>Vendor Master</span>
            </div>
            <div onClick={() => clickOnMenuName("/packagemaster", 8)}>
              <img
                src="./images/svg/package-master.svg"
                className="sideBar_image" alt=""
              />
              <span className={`${navigationId === 8 ? 'left-menu-select' : ''}`}>Package Master</span>
            </div>
            <div onClick={() => clickOnMenuName("/subscription", 9)}>
              <img
                src="./images/svg/subscription.svg"
                className="sideBar_image" alt=""
              />
              <span className={`${navigationId === 9 ? 'left-menu-select' : ''}`}>Subscriptions</span>
            </div> */}
            <div onClick={() => clickOnMenuName("/domaincertificate", 11)}>
              <img
                src="./images/svg/domaincertificate.svg"
                className="sideBar_image" alt=""
              />
              <span className={`${navigationId === 11 ? 'left-menu-select' : ''}`}>Domain Certificates</span>
            </div>
            <div onClick={() => clickOnMenuName("/servicewatch", 12)}>
              <img
                src="./images/svg/service-watch.svg"
                className="sideBar_image" alt=""
              />
              <span className={`${navigationId === 12 ? 'left-menu-select' : ''}`}>Service Watch</span>
            </div>
            {/* <div onClick={() => clickOnMenuName("/versionhistory", 13)}>
              <img
                src="./images/svg/connectionencryptdescript.svg"
                className="sideBar_image" alt=""
              />
              <span className={`${navigationId === 13 ? 'left-menu-select' : ''}`}>Version History</span>
            </div> */}
            <div>
              <div onClick={() => { setPlusMinusVersion(!plusMinusVersion); clickOnMenuName(null, 13) }}>
                <img className="sideBar_image plus-minus-width-height" src={`/images/svg/${plusMinusVersion ? "minus" : "plus"}.svg`} alt="" />
                <img className="sideBar_image" src="./images/svg/version-history.svg" alt="" />
                <span className={`${navigationId === 13 ? 'left-menu-select' : ''}`}>Version History</span>
              </div>
              {plusMinusVersion &&
                <div className="main_ul main_ul_left_padding">
                  <span className={"empty_span"}></span>
                  <div
                    className="main_li">
                    <div className="remove_arrow_summary"
                      onClick={() => clickOnMenuName("/versionnumbering", 15)}
                    >
                      <>
                        <img className="sideBar_image plus-minus-width-height" src={`/images/svg/${plusMinus} ? "minus" : "plus"}.svg`} alt="" />
                      </>
                      <img className="sideBar_image" src="./images/svg/vendor.svg" alt="" />
                      <span
                        className={`${navigationId === 15 ? 'left-menu-select' : ''}`}>
                        Version Numbers
                      </span>
                    </div>
                  </div>

                  <div
                    className="main_li">
                    <div className="remove_arrow_summary"
                      onClick={() => clickOnMenuName("/versioncontains", 16)}
                    >
                      <>
                        <img className="sideBar_image plus-minus-width-height" src={`/images/svg/${plusMinus} ? "minus" : "plus"}.svg`} alt="" />
                      </>
                      <img className="sideBar_image" src="./images/svg/package-master.svg" alt="" />
                      <span
                        className={`${navigationId === 16 ? 'left-menu-select' : ''}`}>
                        Version Contains
                      </span>
                    </div>
                  </div>
                </div>
              }
            </div>
            <div onClick={() => clickOnMenuName("/connectionencryptdecrypt", 14)}>
              <img
                src="./images/svg/connectionencryptdescript.svg"
                className="sideBar_image" alt=""
              />
              <span className={`${navigationId === 14 ? 'left-menu-select' : ''}`}>Connection Encrypt Decrypt</span>
            </div>
            <div>
              <div onClick={() => { setPlusMinus(!plusMinus); clickOnMenuName(null, 7) }}>
                <img className="sideBar_image plus-minus-width-height" src={`/images/svg/${plusMinus ? "minus" : "plus"}.svg`} alt="" />
                <img className="sideBar_image" src="./images/svg/vendor.svg" alt="" />
                <span className={`${navigationId === 7 ? 'left-menu-select' : ''}`}>B2C Management</span>
              </div>
              {plusMinus &&
                <div className="main_ul main_ul_left_padding">
                  <span className={"empty_span"}></span>
                  <div
                    className="main_li">
                    <div className="remove_arrow_summary"
                      onClick={() => clickOnMenuName("/vendormaster", 8)}
                    >
                      <>
                        <img className="sideBar_image plus-minus-width-height" src={`/images/svg/${plusMinus} ? "minus" : "plus"}.svg`} alt="" />
                      </>
                      <img className="sideBar_image" src="./images/svg/vendor.svg" alt="" />
                      <span
                        className={`${navigationId === 8 ? 'left-menu-select' : ''}`}>
                        Vendor Master
                      </span>
                    </div>
                  </div>

                  <div
                    className="main_li">
                    <div className="remove_arrow_summary"
                      onClick={() => clickOnMenuName("/packagemaster", 9)}
                    >
                      <>
                        <img className="sideBar_image plus-minus-width-height" src={`/images/svg/${plusMinus} ? "minus" : "plus"}.svg`} alt="" />
                      </>
                      <img className="sideBar_image" src="./images/svg/package-master.svg" alt="" />
                      <span
                        className={`${navigationId === 9 ? 'left-menu-select' : ''}`}>
                        Package Master
                      </span>
                    </div>
                  </div>

                  <div
                    className="main_li">
                    <div className="remove_arrow_summary"
                      onClick={() => clickOnMenuName("/subscription", 10)}
                    >
                      <>
                        <img className="sideBar_image plus-minus-width-height" src={`/images/svg/${plusMinus} ? "minus" : "plus"}.svg`} alt="" />
                      </>
                      <img className="sideBar_image" src="./images/svg/subscription.svg" alt="" />
                      <span
                        className={`${navigationId === 10 ? 'left-menu-select' : ''}`}>
                        Subscriptions
                      </span>
                    </div>
                  </div>

                </div>
              }
            </div>
          </div>
        )}
      </div>
      {/* <div className={`main_ul main_ul_left_padding`}>
        <li onClick={()=>navigate('/home')}><img src="./images/svg/home.svg" className="sideBar_image"/><span>Home</span></li>   
        <li onClick={()=>navigate('/licencemaster')}><span>Licence Master</span></li>   
      </div> */}
    </>
  );
}
